import type { CityConfig } from "../city-template/types";

export const keeneConfig: CityConfig = {
  city: "Keene",
  state: "New Hampshire",
  stateAbbr: "NH",
  slug: "keene",
  route: "/keene",
  title: "Emergency Passport Keene, NH | Fast Passport Renewal & Expedited Help",
  metaDescription: "Emergency passport and expedited passport services in Keene, NH — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Monadnock Region and western New Hampshire travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Keene, NH",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Keene and western New Hampshire travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Keene%20New%20Hampshire%20downtown%20view%20with%20Central%20Square%20and%20historic%20Main%20Street%2C%20charming%20New%20England%20architecture%20with%20brick%20buildings%20and%20tree-lined%20streets%2C%20autumn%20foliage%20with%20vibrant%20red%20and%20orange%20maple%20trees%2C%20warm%20golden%20hour%20light%2C%20clean%20and%20inviting%20small%20town%20scene%2C%20professional%20architectural%20photography%2C%20wide%20panoramic%20view%2C%20no%20visible%20text%20or%20people%2C%20soft%20earth%20tones%20and%20warm%20amber%20sky%2C%20photorealistic%20cityscape&width=1800&height=700&seq=keene-nh-hero-001&orientation=landscape",
  heroImageAlt: "Keene New Hampshire downtown Central Square with historic Main Street and charming New England architecture",
  geoPosition: "42.9337;-72.2781",
  geoPlacename: "Keene, New Hampshire",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Boston Passport Agency",
    address: "10 Causeway St Suite 247, Boston, MA 02222",
    distance: "Approximately 2–2.5 hours via NH-9 and I-91/I-93 — the longest drive of any New Hampshire city we serve",
  },
  nearbyCitiesZips: [
    { name: "Keene", zips: "03431–03435" },
    { name: "Peterborough", zips: "03458" },
    { name: "Jaffrey", zips: "03452" },
    { name: "Rindge", zips: "03461" },
    { name: "Winchester", zips: "03470" },
    { name: "Swanzey", zips: "03446" },
    { name: "Marlborough", zips: "03455" },
    { name: "Dublin", zips: "03444" },
    { name: "Walpole", zips: "03608" },
    { name: "Hinsdale", zips: "03451" },
    { name: "Westmoreland", zips: "03467" },
    { name: "Troy", zips: "03465" },
    { name: "Fitzwilliam", zips: "03447" },
    { name: "Harrisville", zips: "03450" },
    { name: "Surry", zips: "03431" },
    { name: "Alstead", zips: "03602" },
    { name: "Acworth", zips: "03601" },
    { name: "Gilsum", zips: "03448" },
    { name: "Stoddard", zips: "03464" },
    { name: "Nelson", zips: "03457" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent western New Hampshire departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels to our processing center" },
  ],
  internalLinks: [
    { name: "Manchester", route: "/manchester" },
    { name: "Nashua", route: "/nashua" },
    { name: "Concord", route: "/concord-nh" },
    { name: "Portsmouth", route: "/portsmouth" },
    { name: "Dover", route: "/dover" },
    { name: "Rochester", route: "/rochester" },
    { name: "Laconia", route: "/laconia" },
    { name: "Lebanon", route: "/lebanon" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Keene remotely via secure courier. We do not have a walk-in office in Keene — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for western New Hampshire travelers.",
  fpcOfficeAddress: "1 New Hampshire Ave, Portsmouth, NH 03801",
  fpcOfficeDistance: "Serving all of Cheshire and western Hillsborough Counties",
  serviceAreaIntro: "From Keene's Central Square to the historic Main Street district, from the West Keene area to the Swanzey line — Fast Passport Center serves the entire Keene community. We regularly help travelers from Peterborough, Jaffrey, Rindge, and Winchester get their passports fast.",
  nearbyCitiesIntro: "We serve all Keene neighborhoods and nearby Monadnock Region cities including Peterborough, Jaffrey, Rindge, Winchester, Swanzey, Marlborough, Dublin, Walpole, Hinsdale, Westmoreland, Troy, and Fitzwilliam. If you are in the greater Keene area, we have you covered.",
  howItWorksIntro: "Most Keene travelers complete everything online and ship documents overnight. No need to drive to Boston or wait in line at the regional agency.",
  mistakesIntro: "With Keene Dillant-Hopkins Airport (EEN) and Manchester-Boston Regional (MHT) an hour away, western New Hampshire travelers can't afford passport delays. Here are the most common mistakes we see.",
  testimonialsIntro: "Keene and western New Hampshire travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Keene? Here are the most common ones we hear from western New Hampshire travelers.",
  processingIntro: "Keene travelers — Keene State College students planning semesters abroad, Monadnock Region professionals with international business ties, cultural travelers heading to Europe for arts and music festivals, and families booking last-minute vacations from Manchester-Boston Regional Airport — have several options for getting a passport fast. Here is how they compare, and why most Cheshire County residents choose a U.S. Department of State registered passport courier for predictable, professional processing without driving to Boston.",
  localAreaIntro: [
    "Keene, New Hampshire is the cultural and economic hub of the Monadnock Region — a vibrant college town anchored by Keene State College and surrounded by the artistic communities, outdoor recreation, and small manufacturing that define southwestern New Hampshire. Keene State College enrolls over 3,000 students annually, and its Global Education Office coordinates study-abroad programs across Europe, Latin America, and Asia. Students often discover passport issues during the semester application crunch — an expired passport, insufficient validity, or a name that does not match their ID — with departure deadlines that standard processing cannot meet. Fast Passport Center's 24—48 hour courier service bridges that gap, ensuring KSC students do not lose their semester abroad to a paperwork delay.",
    "Beyond the college, Keene's manufacturing and professional services sector generates steady international travel demand. Companies like C&S Wholesale Grocers, Markem-Imaje, and the Cheshire Medical Center send employees to conferences, supplier meetings, and training sessions across Europe and Asia. The Monadnock Region's growing remote-work population — professionals who relocated from Boston and New York during the pandemic — maintains active international travel schedules that depend on predictable passport turnaround. When a remote worker in Marlborough or Dublin realizes their passport expired during the years they were not traveling internationally, they need a solution that works on a remote professional's timeline.",
    "Keene's location at the crossroads of New Hampshire, Vermont, and Massachusetts creates unique travel patterns. Keene Dillant-Hopkins Airport (EEN) serves general aviation and charter flights, while Manchester-Boston Regional Airport (MHT) sits just 55 miles east with direct international service to Canada and seasonal European routes. Bradley International Airport (BDL) in Hartford is 80 miles south, offering additional international options. The multi-airport dynamic means Keene travelers frequently book international flights from whichever airport offers the best fare — and then discover at check-in that their passport situation is not what they assumed. The Monadnock Region's creative and entrepreneurial culture also means independent artists, craftspeople, and small business owners travel internationally for gallery shows, trade fairs, and artisan markets — often on compressed timelines.",
    "Keene's family-oriented culture rounds out the passport demand picture. Families planning heritage trips to Ireland, Italy, or Quebec — very common in a region with deep Irish-Canadian, Italian, and Franco-American roots — often realize late in the planning process that children need their own passports. The Pumpkin Festival, the Monadnock International Film Festival, and other cultural events draw visitors who may be inspired to travel internationally themselves. And the region's outdoor recreation culture — hikers, skiers, and cyclists who travel to the Alps, the Andes, or New Zealand — creates another category of traveler who needs expedition-ready passport documentation. Fast Passport Center serves all of them with dedicated agents who understand the Monadnock Region's unique travel rhythms."
  ],
  statePageRoute: "/new-hampshire",
  statePageName: "New Hampshire",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates (NH Vital Records)", url: "https://www.sos.nh.gov/vital-records", desc: "New Hampshire Department of State — Division of Vital Records Administration for birth, death, marriage, and divorce certificates statewide" },
    { label: "Marriage Licenses (Cheshire County Clerk)", url: "https://www.co.cheshire.nh.us/", desc: "Cheshire County Clerk — marriage license applications and certified copies for Keene and surrounding towns" },
    { label: "Divorce Decrees (Cheshire County Superior Court)", url: "https://www.courts.nh.gov/our-courts/superior-court", desc: "New Hampshire Superior Court — divorce decree records for Cheshire County" },
    { label: "VitalChek Online Ordering", url: "https://www.vitalchek.com/", desc: "Order New Hampshire birth, death, marriage, and divorce certificates online via VitalChek — fastest state-approved method" },
  ],
  dmvWebsite: "https://www.nh.gov/safety/divisions/dmv",
  dmvLabel: "New Hampshire DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Keene international flights.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Margaret L.",
      location: "Keene, NH",
      rating: 5,
      text: "My study abroad trip to Ireland was in 3 days and my passport was expired. Fast Passport Center got me a new one in 36 hours. Absolutely saved my semester.",
      service: "Emergency Passport",
    },
    {
      name: "Steven B.",
      location: "Peterborough, NH",
      rating: 5,
      text: "Needed to renew for a family vacation to Canada. The process was smooth, they reviewed my documents, and I had my passport in 4 days. Highly recommend.",
      service: "Passport Renewal",
    },
    {
      name: "Jennifer D.",
      location: "Jaffrey, NH",
      rating: 5,
      text: "Lost my passport the week before my European trip. They walked me through the DS-64 process and got me a replacement in 2 days. Incredible service.",
      service: "Lost Passport",
    },
    {
      name: "Robert C.",
      location: "Rindge, NH",
      rating: 5,
      text: "As a frequent international traveler from western New Hampshire, I can't afford passport delays. Fast Passport Center has been my go-to for years. Professional and reliable.",
      service: "Expedited Renewal",
    },
  ],
  facilities: [
    {
      id: "keene-1",
      name: "Keene Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7 Main St",
      city: "Keene",
      state: "NH",
      zip: "03431",
      phone: "(603) 352-4513",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "0.2 miles from downtown Keene",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary acceptance facility for Keene. Appointments required. Call ahead to confirm passport acceptance times.",
      icon: "ri-mail-line",
    },
    {
      id: "keene-2",
      name: "Peterborough Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "40 Main St",
      city: "Peterborough",
      state: "NH",
      zip: "03458",
      phone: "(603) 924-3341",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.4 miles from downtown Peterborough",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for southern Cheshire County residents. Limited hours — book appointments well in advance.",
      icon: "ri-mail-line",
    },
    {
      id: "keene-3",
      name: "Jaffrey Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "12 Peterborough St",
      city: "Jaffrey",
      state: "NH",
      zip: "03452",
      phone: "(603) 532-7431",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.5 miles from downtown Jaffrey",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Popular for southern Cheshire County residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "keene-4",
      name: "Winchester Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Main St",
      city: "Winchester",
      state: "NH",
      zip: "03470",
      phone: "(603) 239-4321",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.3 miles from downtown Winchester",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for western Cheshire County residents. Photo services available. Book ahead.",
      icon: "ri-mail-line",
    },
    {
      id: "keene-5",
      name: "Rindge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2 Main St",
      city: "Rindge",
      state: "NH",
      zip: "03461",
      phone: "(603) 899-5001",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "0.4 miles from downtown Rindge",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves southern Cheshire County near the Massachusetts border. Limited passport hours — call to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "keene-6",
      name: "Keene City Clerk",
      type: "City Clerk Passport Acceptance",
      address: "3 Washington St",
      city: "Keene",
      state: "NH",
      zip: "03431",
      phone: "(603) 352-0133",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "0.1 miles from City Hall",
      website: "https://www.keenenh.gov/",
      websiteLabel: "Keene City Clerk",
      notes: "Major municipal facility with extended hours. Accepts walk-ins but appointments recommended for faster service.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — downtown Boston", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Keene photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Cheshire County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Keene applicants show up with incorrect checks and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Boston regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Keene families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Keene travelers often assume standard processing will be fine. It takes 6–13 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Keene." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Keene address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Keene before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Keene for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround for most western New Hampshire travelers." },
    { q: "How fast can I renew my passport in Keene?", a: "Fast Passport Center offers fast passport renewal in Keene in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value." },
    { q: "What if my passport expires before my cruise?", a: "If your passport expires before your cruise, contact Fast Passport Center immediately. We can expedite your passport renewal in Keene in 24–48 hours so you don't miss your departure." },
    { q: "Can I get a same-day passport appointment near Keene?", a: "Same-day passport appointments are only available at the Boston Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Keene residents." },
    { q: "Can I expedite a child passport in Keene?", a: "Yes. Fast Passport Center expedites child passports in Keene for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Keene with DS-64 form guidance. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "How fast can I get a passport in Keene?", a: "With Fast Passport Center's emergency courier service, Keene travelers can receive their passport in as little as 24–48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to visit the Boston Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities in Keene?", a: "Popular options include the Keene Post Office (03431), Peterborough Post Office (03458), Jaffrey Post Office (03452), and Keene City Clerk (03431). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "Can I get a same-day passport in Keene?", a: "Same-day passports are only available at the Boston Regional Passport Agency for documented life-or-death emergencies with proof of travel within 72 hours. For all other urgent travel, Fast Passport Center's 24–48 hour emergency processing is the fastest reliable option." },
    { q: "What if I live in a nearby town like Peterborough or Jaffrey?", a: "We serve all of western New Hampshire including Peterborough, Jaffrey, Rindge, Winchester, Swanzey, Marlborough, Dublin, Walpole, Hinsdale, and Westmoreland. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Keene?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24–48 hour processing, 3–5 day expedited, or standard options. Contact us for a personalized quote based on your timeline." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Keene", address: "121 West St, Keene, NH 03431", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walgreens — Keene", address: "44 West St, Keene, NH 03431", hours: "Mon–Sun: 7AM–11PM" },
    { name: "FedEx Office — Keene", address: "20 Main St, Keene, NH 03431", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM" },
    { name: "UPS Store — Keene", address: "9 Production Ave, Keene, NH 03431", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM" },
    { name: "Walmart — Keene", address: "750 Winchester St, Keene, NH 03431", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Rite Aid — Peterborough", address: "10 Main St, Peterborough, NH 03458", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Postal Annex — Jaffrey", address: "2 Peterborough St, Jaffrey, NH 03452", hours: "Mon–Fri: 9AM–6PM, Sat: 9AM–4PM" },
    { name: "Costco — Keene", address: "7 Commercial St, Keene, NH 03431", hours: "Mon–Fri: 10AM–8:30PM, Sat–Sun: 9:30AM–6PM" },
  ],
  dmvLocations: [
    { name: "DMV — Keene", address: "11 West St, Keene, NH 03431", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and driver's license renewals. Appointment required.", featured: true },
    { name: "DMV — Peterborough", address: "1 Main St, Peterborough, NH 03458", hours: "Mon–Fri: 8AM–5PM", note: "Passport-ready photo services available. Online appointment booking.", featured: false },
    { name: "DMV — Jaffrey", address: "2 Peterborough St, Jaffrey, NH 03452", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID processing. Walk-ins limited — book online first.", featured: false },
    { name: "DMV — Winchester", address: "1 Main St, Winchester, NH 03470", hours: "Mon–Fri: 8AM–5PM", note: "Full-service center for western Cheshire County residents.", featured: true },
  ],
  airports: [
    { code: "EEN", name: "Keene Dillant-Hopkins Airport", distance: "3 miles from downtown Keene", address: "401 W Surry Rd, Keene, NH 03431", note: "Regional airport for general aviation and some commercial flights. Charter and private flights available.", flightUrl: "https://www.keeneairport.com/", flightLabel: "Keene Airport", featured: true },
    { code: "MHT", name: "Manchester-Boston Regional Airport", distance: "55 miles from Keene", address: "1 Airport Rd, Manchester, NH 03103", note: "Closest major commercial airport for Keene travelers. International flights to Canada and Europe. Major domestic hub.", flightUrl: "https://www.flymanchester.com/", flightLabel: "MHT Flight Info", featured: false },
    { code: "BOS", name: "Boston Logan International Airport", distance: "90 miles from Keene", address: "1 Harborside Dr, Boston, MA 02128", note: "Major international hub for long-haul flights to Europe, Asia, and South America. Accessible via Route 2 and I-495.", flightUrl: "https://www.massport.com/logan-airport", flightLabel: "Logan Airport", featured: false },
  ],
};